import { useEffect } from 'react';
import StoryTimeline from '@/components/StoryTimeline';

export default function StoryPage() {
  useEffect(() => {
    document.title = 'THE STORY BEGINS — ARC TOONS';
  }, []);

  return <StoryTimeline />;
}
